import Svg from '../../Atoms/Svg'
import Typography from '../../Atoms/Typography'
import styles from './AvailabilityBlock.module.scss'

import React from 'react'

const AvailabilityBlock = ({ productObj }) => {
  const availability = {
    message: productObj.availability ? productObj.availability.replace(/([A-Z])/g, ' $1').trim() : null,
    intent: null,
    svg: null,
  }

  if (productObj.availability === 'InStock') {
    availability.intent = 'positive'
    availability.svg = 'check'
  } else if (productObj.availability === 'Discontinued' || productObj.availability === 'NotAvailable') {
    availability.intent = 'negative'
    availability.svg = 'unavailable'
  } else if (productObj.availability === 'Backorderable') {
    availability.intent = 'warning'
    availability.message = 'On Backorder'
    availability.svg = 'backordered'
  } else if (productObj.availability === 'FactoryShipped') {
    availability.svg = 'factory_shipped'
  } else if (productObj.availability === 'MadeToOrder') {
    availability.svg = 'made_to_order'
  }

  return (
    <Typography
      data-testid={`availabilityBlock_skuBaseNumber_${productObj.skuBaseNumber}`}
      size={1}
      className={`${styles.availability} ${styles.row}`}
      intent={availability.intent}
    >
      {availability.svg && <Svg icon={availability.svg} intent={availability.intent} size={1} />}
      {availability.message}
    </Typography>
  )
}

export default AvailabilityBlock
